import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function FramoTable({ data, onEdit }) {
  const columns = [
    {
      title: "Framo System Name",
      dataIndex: "framo_name",
      key: "framo_name",
      align: "center",
    },
    {
      title: "Framo System Maker",
      dataIndex: "framo_maker",
      key: "framo_maker",
      align: "center",
    },
    {
      title: "Framo System Model",
      dataIndex: "framo_model",
      key: "framo_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
